


















































import { IDateGroup } from "../models";
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import moment from "moment";

@Component
export default class DateSearchForm extends Vue {
    fromDate: string | null = null;
    toDate: string | null = null;
    dateView: IDateGroup | null = null;

    /**
     * Format date method for comparison against the selected `dateView` above.
     * See datesChanged
     */
    formatDate(date: Date): string {
        // https://momentjs.com/docs/#/parsing/special-formats/
        // HTML5_FMT.DATE is the HTML5 datepicker format.
        return moment(date).format(moment.HTML5_FMT.DATE);
    }

    clear(): void {
        this.fromDate = null;
        this.toDate = null;
        this.$emit("clear");
    }

    search(): void {
        if (!this.fromDate || !this.toDate) {
            return;
        }

        // Emit a search event with dates from the start of the day "12:00 am" to the end of the day "11:59 pm"
        this.$emit(
            "search",
            moment(this.fromDate)
                .startOf("day")
                .format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS),
            moment(this.toDate)
                .endOf("day")
                .format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)
        );
    }

    @Watch("fromDate")
    @Watch("toDate")
    datesChanged(): void {
        if (!this.dateView) {
            return;
        }

        const toDate = this.formatDate(this.dateView.endDate);
        const fromDate = this.formatDate(this.dateView.startDate);

        // If the toDate or fromDate change and they no longer match
        // the content of the date view selector, set that value to null.
        if (this.toDate != toDate || this.fromDate != fromDate) {
            this.dateView = null;
        }
    }

    @Watch("dateView")
    dateViewSelected(): void {
        if (!this.dateView) {
            return;
        }

        this.toDate = this.formatDate(this.dateView.endDate);
        this.fromDate = this.formatDate(this.dateView.startDate);
    }
}
